import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

/**
 * Shared experience confirm dialog (Cancel + destructive confirm).
 * Pass title / message / button labels per use case.
 */
const ExperienceConfirmModal = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  cancelLabel = 'Cancel',
  confirmLabel = 'Delete',
  loadingLabel = 'Working…',
  isLoading = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop={isLoading ? 'static' : true}
      keyboard={!isLoading}
      dialogClassName='experience-confirm-dialog'
      contentClassName='experience-confirm-card'>
      <Modal.Body className='p-0'>
        <div className='experience-confirm-body'>
          <h2>{title}</h2>
          {message ? (
            <p className='experience-confirm-lead'>{message}</p>
          ) : null}
          <div className='experience-modal-actions'>
            <button
              type='button'
              className='btn-outline-experience'
              onClick={onHide}
              disabled={isLoading}>
              {cancelLabel}
            </button>
            <button
              type='button'
              className='btn-danger-experience'
              onClick={onConfirm}
              disabled={isLoading}>
              {isLoading ? loadingLabel : confirmLabel}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

ExperienceConfirmModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.node,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  loadingLabel: PropTypes.string,
  isLoading: PropTypes.bool,
}

export default ExperienceConfirmModal
